"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var auth_1 = require("../auth");
var react_toastify_1 = require("react-toastify");
var FloatingLabelInput_1 = require("./FloatingLabelInput");
var ErrorMessageComponent_1 = require("./ErrorMessageComponent");
var CommonHeader_1 = require("./CommonHeader");
var react_intl_1 = require("react-intl");
var ReactPasswordStrength_1 = require("./ReactPasswordStrength");
var glamor_1 = require("glamor");
require("font-awesome/css/font-awesome.min.css");
require("react-toastify/dist/ReactToastify.css");
var ForgotPasswordStyle_1 = require("./ForgotPasswordStyle");
var App_1 = require("./App");
var img = require('../greenBackground.jpg');
var ResetPassword = function (props) {
    var context = react_1.useContext(App_1.LanguageContext);
    var _a = react_1.useState(props.email ? props.email : ''), preferred_username = _a[0], setPreferredUsername = _a[1];
    var _b = react_1.useState(''), password = _b[0], setPassword = _b[1];
    var _c = react_1.useState(''), authCode = _c[0], setAuthCode = _c[1];
    var _d = react_1.useState(false), inlineErrorPassword = _d[0], setInlineErrorPassword = _d[1];
    var _e = react_1.useState(false), inlineErrorAuthCode = _e[0], setInlineErrorAuthCode = _e[1];
    var _f = react_1.useState(false), pass = _f[0], setPass = _f[1];
    var _g = react_1.useState(false), showMessage = _g[0], setShowMessage = _g[1];
    var _h = react_1.useState(''), message = _h[0], setMessage = _h[1];
    var _j = react_1.useState(false), loading = _j[0], setLoading = _j[1];
    var updatePassword = function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (password === '') {
                        setInlineErrorPassword(true);
                        setPass(false);
                        setShowMessage(false);
                        setMessage('');
                        setLoading(false);
                    }
                    if (authCode === '') {
                        setInlineErrorAuthCode(true);
                        setPass(false);
                        setShowMessage(false);
                        setMessage('');
                        setLoading(false);
                    }
                    if (!(password !== '' && authCode !== '')) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    setLoading(true);
                    return [4 /*yield*/, auth_1.InfoAuth.forgotPasswordSubmit(preferred_username, authCode, password)];
                case 2:
                    _a.sent();
                    setShowMessage(false);
                    react_toastify_1.toast.success('Password Changed Successfully!', {
                        autoClose: 15000,
                        className: glamor_1.css({
                            backgroundColor: 'rgb(227, 252, 239)!important',
                            boxShadow: 'rgba(0, 0, 0, 0.176) 0px 3px 8px !important',
                            color: 'rgb(0, 102, 68)  !important',
                            transform: 'translate3d(0px, 0px, 0px)',
                            borderRadius: '4px',
                            borderLeft: '5px solid rgb(54, 179, 126) !important',
                            transition: 'transform 220ms cubic-bezier(0.2, 0, 0, 1) 0s'
                        })
                    });
                    setTimeout(function () {
                        props.history.push('/login');
                    }, 5000);
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    setLoading(false);
                    if (err_1.message != null) {
                        setPass(false);
                        setShowMessage(true);
                        setMessage(err_1.message);
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var resend = function () {
        setPass(false);
        setShowMessage(false);
        setMessage('');
        setInlineErrorPassword(false);
        setInlineErrorAuthCode(false);
        setPreferredUsername('');
        props.history.push('/forgotPassword');
    };
    return (React.createElement("div", null,
        React.createElement(react_toastify_1.ToastContainer, { hideProgressBar: true }),
        React.createElement(CommonHeader_1.default, __assign({ setLanguage: context.setLanguage }, props)),
        React.createElement(ForgotPasswordStyle_1.ParentWrapperContainer, { image: img },
            React.createElement(ForgotPasswordStyle_1.ForgotPasswordContainer, null,
                React.createElement(ForgotPasswordStyle_1.WrapperContainer, null,
                    React.createElement(ForgotPasswordStyle_1.Form, null,
                        React.createElement(ForgotPasswordStyle_1.ChangePassTitleSpanContainer, { showMessage: showMessage },
                            React.createElement("strong", null,
                                React.createElement(react_intl_1.FormattedMessage, { id: "resetPwd.resetpassword" }))),
                        React.createElement(ErrorMessageComponent_1.default, { pass: pass, showMessage: showMessage, message: message }),
                        React.createElement(FloatingLabelInput_1.FloatingLabelInput, { id: "authcode", dispalyLabel: React.createElement(react_intl_1.FormattedMessage, { id: "resetPwd.passcode" }), onChange: setAuthCode, value: authCode, inlineError: inlineErrorAuthCode, setInLineError: setInlineErrorAuthCode, type: "text", inlineMsg: React.createElement(react_intl_1.FormattedMessage, { id: "resetPwd.inlineMsgAuth" }) }),
                        React.createElement(ReactPasswordStrength_1.default, __assign({}, props, { intl: props.intl, id: "Password", dispalyLabel: React.createElement(react_intl_1.FormattedMessage, { id: "resetPwd.newPassword" }), onChange: setPassword, value: password, inlineError: inlineErrorPassword, setInLineError: setInlineErrorPassword, type: "password", inlineMsg: React.createElement(react_intl_1.FormattedMessage, { id: "resetPwd.newPwdIsRequired" }) })),
                        React.createElement(ForgotPasswordStyle_1.CustomButton, { size: "lg", onClick: updatePassword, loading: loading },
                            ' ',
                            React.createElement(react_intl_1.FormattedMessage, { id: "resetPwd.btnResetPassword" }),
                            ' '),
                        React.createElement(ForgotPasswordStyle_1.RedirectContainer, null,
                            React.createElement(ForgotPasswordStyle_1.LinkComponent, { to: "/login" },
                                React.createElement(ForgotPasswordStyle_1.LinkSpan, { showMessage: showMessage },
                                    React.createElement(react_intl_1.FormattedMessage, { id: "resetPwd.backToLogin" }))),
                            React.createElement(ForgotPasswordStyle_1.LinkSpan, { showMessage: showMessage, onClick: resend },
                                ' ',
                                React.createElement(react_intl_1.FormattedMessage, { id: "resetPwd.resend" }),
                                ' '))))))));
};
exports.default = react_intl_1.injectIntl(react_router_dom_1.withRouter(ResetPassword));
//# sourceMappingURL=ResetPassword.js.map